



































































import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

@Component
export default class Settings extends Vue {
  @Action('TOGGLE_THEME') private actionTheme!: (payload: { currentTheme: string }) => void
  @Action('TOGGLE_LANG') private actionLang!: (payload: { currentLang: string }) => void
  @Action('SET_MAX_RECONNECT_TIMES') private actionMaxReconnectTimes!: (payload: { maxReconnectTimes: number }) => void
  @Getter('currentTheme') private getterTheme!: 'light' | 'dark' | 'night'
  @Getter('currentLang') private getterLang!: Language
  @Getter('maxReconnectTimes') private getterMaxReconnectTimes!: number

  private currentTheme: 'light' | 'dark' | 'night' = 'light'
  private currentLang: Language = 'en'
  private maxReconnectTimes = 10
  private langOptions: Options[] = [
    { label: '简体中文', value: 'zh' },
    { label: 'English', value: 'en' },
    { label: '日本語', value: 'ja' },
  ]
  private themeOptions: Options[] = [
    { label: 'Light', value: 'light' },
    { label: 'Dark', value: 'dark' },
    { label: 'Night', value: 'night' },
  ]

  private handleSelectChange(type: 'lang' | 'theme', value: string | number | boolean): void {
    if (type === 'theme') {
      this.actionTheme({ currentTheme: value as string })
      window.document.body.setAttribute('class', value as string)
    } else if (type === 'lang') {
      this.actionLang({ currentLang: value as string })
      document.documentElement.setAttribute('lang', value as string)
      this.$i18n.locale = value as string
    }
  }

  private handleInputChage(value: number) {
    this.actionMaxReconnectTimes({ maxReconnectTimes: value })
  }

  private created() {
    this.currentTheme = this.getterTheme
    this.currentLang = this.getterLang
    this.maxReconnectTimes = this.getterMaxReconnectTimes
  }
}
